import React from "react";
import { PiTruckFill } from "react-icons/pi";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import "./delivery-progress.scss";

const mapStateToProps = (state: any) => {
  let settings;

  if (state.settings) {
     settings = state.settings
  }

  return {
    settings: settings
  };
};

function DeliveryProgress({
  totalAmount,
  settings,
}: {
  totalAmount: number;
  settings: any;
}) {
  const progress = Math.min((totalAmount / settings.freeDeliveryMinAmount) * 100, 100);

  // if basket is empty, stick the truck at the very start
  const truckLeft = totalAmount === 0 ? "16px" : `calc(${progress}% - 12px)`;

  return (
    <div className="delivery-progress">
      <div className="bar-background">
        <div className="bar-fill" style={{ width: `${progress}%` }} />
        <div className="truck-icon" style={{ left: truckLeft }}>
          <PiTruckFill color="#e74c3c" size={20} />
        </div>
      </div>
      <div className="message">
        <NumberFormat
          displayType="text"
          value={settings.freeDeliveryMinAmount}
          thousandSeparator
          suffix="₮"
        />
        -аас дээш бараа захиалбал <span>үнэгүй хүргэнэ.</span>
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(DeliveryProgress);